// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dashboard_wrapper__1C09e","panel":"Dashboard_panel__IAvdK","panelHeading":"Dashboard_panelHeading__29UKe","panelBody":"Dashboard_panelBody__dJtVR"};